import React from "react";
import { MetaPixel } from "./components/MetaPixel";
import { HeroSection } from "./components/HeroSection";
import { StorySection } from "./components/StorySection";
import { TransformationSection } from "./components/TransformationSection";
import { PainSection } from "./components/PainSection";
import { VolumesSection } from "./components/VolumesSection";
import { ToolsSection } from "./components/ToolsSection";
import { BonusesSection } from "./components/BonusesSection";
import { OfferSection } from "./components/OfferSection";
import { GuaranteeSection } from "./components/GuaranteeSection";
import { TestimonialsSection } from "./components/TestimonialsSection";
import { CreatorSection } from "./components/CreatorSection";
import { FaqSection } from "./components/FaqSection";
import { FinalCtaSection } from "./components/FinalCtaSection";
import { Footer } from "./components/Footer";
import { FloatingCta } from "./components/FloatingCta";
import { PurchasePopup } from "./components/PurchasePopup";
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-cream font-sans" data-id="element-0" data-mp="3ihv0i9zd8dgr">
      <MetaPixel data-id="element-1" data-mp="3mjztr7lwj82v" />
      <HeroSection data-id="element-2" data-mp="3mjg93j4va5l5" />
      <main data-id="element-3" data-mp="3rc9hqi3ghy2i">
        <StorySection data-id="element-4" data-mp="3rbrakqf99zft" />
        <TransformationSection data-id="element-5" data-mp="3rdatkosaqola" />
        <PainSection data-id="element-6" data-mp="3recdzjv7cnfo" />
        <VolumesSection data-id="element-7" data-mp="5yhupa6n3cr" />
        <ToolsSection data-id="element-8" data-mp="67yvnd9206b" />
        <BonusesSection data-id="element-9" data-mp="4n7g6m8exco" />
        <OfferSection data-id="element-10" data-mp="82jt1oitsae" />
        <GuaranteeSection data-id="element-11" data-mp="2zld1d7i6tbah" />
        <TestimonialsSection data-id="element-12" data-mp="2zlv32jnmchps" />
        <CreatorSection data-id="element-13" data-mp="2zmwi0z7r9ocs" />
        <FaqSection data-id="element-14" data-mp="2znfyebhrc4op" />
        <FinalCtaSection data-id="element-15" data-mp="33m5b01uz1i7a" />
      </main>
      <Footer data-id="element-16" data-mp="33n6zb810016y" />
      <FloatingCta data-id="element-17" data-mp="33myix65o2dr0" />
      <PurchasePopup data-id="element-18" data-mp="38lromcepp0gm" />
    </div>;
}